import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://swdmsuserservice.prod.dmsapi.sellwise360.com';
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://apps.oswallet.app/UserService";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const demoService = {
  submitDemoRequest: async (data) => {
    try {
      const response = await apiClient.post('/api/support/requestdemo', data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to submit demo request');
    }
  },
  
  submitContactForm: async (data) => {
    try {
      // Simulate API call - replace with actual endpoint
      const response = await apiClient.post('/api/support/contact', data);
      return response.data;
    } catch (error) {
      console.error('Contact form submission error:', error);
      throw new Error('Failed to submit contact form. Please try again.');
    }
  },
};

export default apiClient;